import { styled } from "@mui/material/styles";
import { InnerContainer } from "../InnerContainer";

export const Container = styled(InnerContainer)`
  width: 280px;
  flex-direction: column;
  user-select: none;
`;
